import conditions from './conditions'
import store from '@/core/store'
import {Alert} from '@/core/utils'

const alert = new Alert(store)
const MSG_REDIRECIONAMENTO_PERFIL = 'As credenciais informadas não têm acesso ao perfil selecionado. Estamos redirecionando você para a área correta. Por favor, tente novamente.'
const COMPRADOR_AUTHORITIES = ['Comprador.Normal', 'Comprador.Admin', 'Comprador.Consulta', 'Comprador.Autoridade.Superior']

class RouterGuards {

    async conditions(to, from, next) {
        const tasks = Object.keys(conditions)
        let nextExecuted = false

        nextExecuted = await tasks.some((condition) => {
            if (conditions[condition].runningCondition(to, from)) {
                next()
                return true
            }
            return false
        })

        if (!nextExecuted) {
            nextExecuted = await tasks.some((condition) => {
                if (conditions[condition].shouldExecute(to, from)) {
                    conditions[condition].execute(to, from, next)
                    return true
                }
                return false
            })
        }

        if (!nextExecuted) {
            if (this.tratarExecucaoCompradorDadosGeraisVisualizacao(to, next)) return
            if (this.tratarFornecedorDetalhes(to, next)) return
        }

        if (!nextExecuted) {
            if (to.meta && to.meta.requiresAuth) {
                const permissionValid = this.possuiAlgumaPermissao(store.state.loki.user.authorities, to.meta.authorities)
                if (permissionValid) {
                    next()
                } else {
                    alert.showError('Você não possui permissão de acesso.')
                    next({ name: 'NaoAutorizado', replace: true })
                }
            } else {
                next()
            }
        }
    }

    tratarExecucaoCompradorDadosGeraisVisualizacao(to, next) {
        if (!to || to.name !== 'DadosGeraisVisualizacao') return false
        const id = this.obterIdCompraDireta(to)
        const user = (store.state && store.state.loki && store.state.loki.user) || {}
        const isFornecedor = this.isFornecedor(user)

        if (isFornecedor) {
            this.notificarRedirecionamentoPerfil()
            next({ name: 'DetalhesCompraDireta', params: { id } })
            return true
        }

        const possuiPerfilComprador = this.possuiAlgumaPermissao(user.authorities || [], COMPRADOR_AUTHORITIES)
        if (!possuiPerfilComprador) {
            next({ name: 'NaoAutorizado' })
            return true
        }
        return false
    }

    tratarFornecedorDetalhes(to, next) {
        if (!to || to.name !== 'DetalhesCompraDireta') return false
        const id = this.obterIdCompraDireta(to)
        const user = (store.state && store.state.loki && store.state.loki.user) || {}
        const isFornecedor = this.isFornecedor(user)

        if (!isFornecedor) {
            const possuiPerfilComprador = this.possuiAlgumaPermissao(user.authorities || [], this.obterAuthoritiesDaRota('DadosGeraisVisualizacao'))
            if (possuiPerfilComprador) {
                this.notificarRedirecionamentoPerfil()
                next({ name: 'DadosGeraisVisualizacao', params: { id } })
                return true
            }
            next({ name: 'NaoAutorizado' })
            return true
        }
        return false
    }

    obterAuthoritiesDaRota(routeName) {
        // procura entre as rotas registradas no vue-router em runtime
        const router = require('@/views/routers').default
        const match = (router && router.options && router.options.routes) || []
        const pegarAuthorities = (route) => (route && route.meta && route.meta.authorities) || null

        const buscar = (routes) => {
            for (const r of routes) {
                if (r.name === routeName) return pegarAuthorities(r)
                if (r.children) {
                    const child = buscar(r.children)
                    if (child) return child
                }
            }
            return null
        }
        return buscar(match) || []
    }

    obterIdCompraDireta(to) {
        if (to && to.params && to.params.id) return to.params.id
        const path = (to && to.path) || ''
        const m = path.match(/\/(comprador\/execucao|fornecedor\/detalhes)\/([^/]+)/)
        return (m && m[2]) || ''
    }

    isFornecedor(user) {
        const tipoDominio = (user && user.domainType) || ''
        const tipoUsuario = (user && user.type) || ''
        const normDominio = String(tipoDominio || '').toUpperCase()
        const normUsuario = String(tipoUsuario || '').toUpperCase()
        return normDominio === 'FORNECEDOR' || normUsuario === 'EXTERNO'
    }

    possuiAlgumaPermissao(authorities, authoritiesRota) {
        const names = (authorities || []).filter(a => a && a.hasAccess).map(a => a.name)
        return (authoritiesRota || []).some(auth => names.indexOf(auth) > -1)
    }

    notificarRedirecionamentoPerfil() {
        setTimeout(() => alert.showError(MSG_REDIRECIONAMENTO_PERFIL))
    }
}

export default new RouterGuards()

